import Home from 'assets/images/footer/home.svg'
import HomeActive from 'assets/images/footer/home-active.svg'
import Funds from 'assets/images/footer/funds.svg'
import FundsActive from 'assets/images/footer/funds-active.svg'
import Transactions from 'assets/images/footer/transactions.svg'
import TransactionsActive from 'assets/images/footer/transactions-active.svg'
import Messages from 'assets/images/footer/messages.svg'
import MessagesActive from 'assets/images/footer/messages-active.svg'
interface IMenu {
    title: string
    icon: string
    activeIcon: string
    route: string
    isMain?: boolean
    main: boolean
    role: string
}

export const footerItems: Array<IMenu> = [
    {
        role: 'home',
        title: 'خانه',
        icon: Home,
        route: '/home',
        main: false,
        activeIcon: HomeActive,
    },
    {
        role: 'Funds',
        title: 'صندوق ها',
        icon: Funds,
        route: '/funds',
        main: false,
        activeIcon: FundsActive,
    },
    {
        role: 'Transactions',
        title: 'تراکنش ها',
        icon: Transactions,
        route: '/transactions',
        main: true,
        activeIcon: TransactionsActive,
    },
    {
        role: 'Messages',
        title: 'پیام ها',
        icon: Messages,
        route: '/messages',
        main: false,
        activeIcon: MessagesActive,
    },
]
